<template>
  <header id="site-header" :class="{'pc':!isWindow }">
    <figure class="logo">
      <a href="/top/">
        <img src="/images/common/logo_w.webp" alt="成田山 新勝寺門前旅館 若松本店" />
      </a>
    </figure>
    <div class="trg" @click="trg = !trg" :class="{'active': trg}" v-if="isWindow">
      <i></i>
      <i></i>
      <i></i>
    </div>

    <ul v-if="!isWindow" class="gnavi">
      <li itemprop="name"><a itemprop="url" href="/rooms/" data-eng="Rooms">お部屋</a></li>
      <li itemprop="name"><a itemprop="url" href="/dishes/" data-eng="Dishes">お料理</a></li>
      <li itemprop="name"><a itemprop="url" href="/facilities/" data-eng="Facilities">館内施設</a></li>
      <li itemprop="name"><a itemprop="url" href="/access/" data-eng="Access">アクセス</a></li>
      <li itemprop="name"><a itemprop="url" href="/plan/" data-eng="Day use">日帰り</a></li>
      <li itemprop="name"><a itemprop="url" href="/faq/" data-eng="FAQ">よくある質問</a></li>
      <li itemprop="name"><a data-eng="Plan" href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445" target="_blank" rel="nofollow">宿泊プラン<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h224.61v40H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h510.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-224.61h40v224.61q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Zm164.92-201.23-28.31-28.31L731.69-760H560v-40h240v240h-40v-171.69L389.54-361.23Z"></path></svg></a></li>
    </ul>

    <a href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445" target="_blank" rel="nofollow" class="other" :class="{'active': trg, 'pc':!isWindow }">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M700-100v-120H580v-40h120v-120h40v120h120v40H740v120h-40ZM224.62-200q-27.62 0-46.12-18.5Q160-237 160-264.62v-430.76q0-27.62 18.5-46.12Q197-760 224.62-760h70.76v-89.23h43.08V-760h206.16v-89.23h40V-760h70.76q27.62 0 46.12 18.5Q720-723 720-695.38v228.61q-10-.69-20-.69t-20 .69v-68.61H200v270.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h266.92q0 10 .69 20t2.54 20H224.62ZM200-575.39h480v-119.99q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v119.99Zm0 0V-720-575.39Z"/></svg>
        ご予約<br>Reservation
      </div>
    </a>

    <label class="lang" :class="{'pc':!isWindow }">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480.13-120q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120ZM440-162v-78q-33 0-56.5-23.5T360-320v-40L168-552q-3 18-5.5 36t-2.5 36q0 121 79.5 212T440-162Zm276-102q41-45 62.5-100.5T800-480.29q0-98.47-54.12-179.86Q691.77-741.54 600-777.54V-760q0 33-23.5 56.5T520-680h-80v80q0 17-11.5 28.5T400-560h-80v80h240q17 0 28.5 11.5T600-440v120h40q26 0 47 15.5t29 40.5Z"/></svg>
      </span>
      <select @change="changeLocal" v-model="lang">
        <option :value="langDefault" selected>Booking.com</option>
        <option value="https://www.booking.com/hotel/jp/wakamatsu-honten.html?label=gen173nr-15CAsodUIQd2FrYW1hdHN1LWhvbnRlbkgzYgVub3JlZmh1iAEBmAEVuAEEyAEE2AED6AEB&sid=d2e741ab92cc0daa143e002a785d4cc7&dcid=1&dist=0&sb_price_type=total&type=total&lang=en-us&soz=1&lang_changed=1&explicit_lang_change=1">English</option>
        <option value="https://www.booking.com/hotel/jp/wakamatsu-honten.ko.html?label=gen173nr-15CAsodUIQd2FrYW1hdHN1LWhvbnRlbkgzYgVub3JlZmh1iAEBmAEVuAEEyAEE2AED6AEB&sid=d2e741ab92cc0daa143e002a785d4cc7&dcid=1&dist=0&sb_price_type=total&type=total&lang=ko&soz=1&lang_changed=1&explicit_lang_change=1">韓国語</option>
        <option value="https://www.booking.com/hotel/jp/wakamatsu-honten.zh-cn.html?label=gen173nr-15CAsodUIQd2FrYW1hdHN1LWhvbnRlbkgzYgVub3JlZmh1iAEBmAEVuAEEyAEE2AED6AEB&sid=d2e741ab92cc0daa143e002a785d4cc7&dcid=1&dist=0&sb_price_type=total&type=total&lang=zh-cn&soz=1&lang_changed=1&explicit_lang_change=1">中国語簡体</option>
        <option value="https://www.booking.com/hotel/jp/wakamatsu-honten.zh-tw.html?label=gen173nr-15CAsodUIQd2FrYW1hdHN1LWhvbnRlbkgzYgVub3JlZmh1iAEBmAEVuAEEyAEE2AED6AEB&sid=d2e741ab92cc0daa143e002a785d4cc7&dcid=1&dist=0&sb_price_type=total&type=total&lang=zh-tw&soz=1&lang_changed=1&explicit_lang_change=1">中国語繁体</option>
      </select>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg>
    </label>

    <Transition name="nav">
      <div class="fix" v-if="trg">
        <nav class="gnavi" role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
          <figure class="logo">
            <a href="/top/">
              <img src="/images/common/logo_w.webp" alt="成田山 新勝寺門前旅館 若松本店" />
            </a>
          </figure>
          <div class="pics" :class="{'active':trg}">
            <figure><img src="/images/common/menu_pic_01.webp" alt="写真"></figure>
          </div>
          <div class="menu">
            <ul :class="{'active':trg}">
              <li itemprop="name"><a itemprop="url" href="/rooms/" data-eng="Rooms">お部屋</a></li>
              <li itemprop="name"><a itemprop="url" href="/dishes/" data-eng="Dishes">お料理</a></li>
              <li itemprop="name"><a itemprop="url" href="/facilities/" data-eng="Facilities">館内施設</a></li>
              <li itemprop="name"><a itemprop="url" href="/access/" data-eng="Access">アクセス</a></li>
              <li itemprop="name"><a itemprop="url" href="/access/#sec_c" data-eng="Sightseeing" @click="trg = false">周辺観光</a></li>
              <li itemprop="name"><a itemprop="url" href="/plan/" data-eng="Day use">日帰り</a></li>
              <li itemprop="name"><a itemprop="url" href="/faq/" data-eng="FAQ">よくある質問</a></li>
              <li itemprop="name"><a data-eng="Plan" href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445" target="_blank" rel="nofollow">宿泊プラン<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-510.76q0-27.62 18.5-46.12Q197-800 224.62-800h224.61v40H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v510.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h510.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-224.61h40v224.61q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Zm164.92-201.23-28.31-28.31L731.69-760H560v-40h240v240h-40v-171.69L389.54-361.23Z"></path></svg></a></li>
            </ul>
            <dl class="meta">
              <dt>〒286-0026 千葉県成田市本町355<br>355 Honcho, Narita-shi, Chiba 286-0026, Japan</dt>
              <dd>TEL.0476-22-1136<br>FAX.0476-24-1347</dd>
            </dl>
          </div>
        </nav>
      </div>
    </Transition>
  </header>
</template>

     

<style lang="scss" scoped>
$spSize: 4.8rem;
.nav-enter-active,
.nav-leave-active {
  transition: opacity 0.5s module.$ease;
}
.nav-enter-from,
.nav-leave-to {
  opacity: 0;
}
header{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 0;
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  @media screen and (max-width: module.$phone){
    position: absolute;
  }
  &.pc{
    &:before{
      height: 25dvh;
      opacity: .8;
    }
  }
  &:before{
    content: '';
    width: 100%;
    height: 15dvh;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(to top, rgba(#000,.0), rgba(#000,1));
    opacity: .4;
    pointer-events: none;
    z-index: -1;
  }
  .logo{
    margin: 1.2rem 0 0 module.side();
    width: 14.4rem;
    justify-self: flex-start;
    @media screen and (max-width: module.$phone){
      width: 10rem;
    }
    img{
      width: 100%;
    }
  }
  .gnavi{
    position: absolute;
    top: 1.6rem;
    left: 50%;
    transform: translate(-50%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: module.$tab){
      top: 0;
      min-height: 100vmax;
    }
    li{
      margin: 0 0 0 2.4rem;
      @media screen and (max-width: module.$tab){
        margin: 0;
      }
      &:first-child{
        margin: 0;
      }
      a{
        font-size: 1.08rem;
        color: module.$white;
        position: relative;
        transition: color 200ms module.$ease;
        &:before{
          content: '';
          width: 0;
          height: 1px;
          background: module.$sub;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          transition: width 200ms module.$ease;
          @media screen and (max-width: module.$tab){
            height: auto;
            left: 0;
            bottom: auto;
            top: 0;
            position: relative;
          }
        }
        &:after{
          content: attr(data-eng);
          font-size: .88rem;
          display: block;
          text-align: center;
        }
        svg{
          width: 1.1rem;
          height: 1.1rem;
          fill: module.$white;
          display: inline-block;
          margin: 0 0 0 .32rem;
          transition: fill 200ms module.$ease;
        }
        &:hover{
          color: module.$sub;
          @media screen and (max-width: module.$tab){
            color: module.$white;
          }
          svg{
            fill: module.$sub;
            @media screen and (max-width: module.$tab){
              fill: module.$white;
            }
          }
          &:before{
            width: 100%;
          }
        }
      }
    }
  }
  .other{
    position: fixed;
    top: 0;
    right: calc(6.4rem - 1px);
    height: 6.4rem;
    background: darken(module.$base, 4%);
    color: module.$gray;
    line-height: 1.5;
    @include module.flex();
    align-items: center;
    justify-content: center;
    padding: 0 2rem;
    z-index: 900;
    border-radius: 0 0 0 1rem;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transition: clip-path 800ms module.$ease, background 400ms module.$ease;
    &.pc{
      right: 0;
    }
    @media screen and (max-width: module.$phone){
      right: calc(#{$spSize} - 1px);
      height: $spSize;
      padding: 0 1.6rem;
    }
    &.active{
      clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 0);
    }
    &:hover{
      background: module.$sub;
    }
    div{
      font-size: .72rem;
      text-align: center;
      @media screen and (max-width: module.$phone){
        font-size: .72rem;
        padding: .32rem 0;
      }
      svg{
        width: 2.4rem;
        fill: module.$gray;
        display: block;
        margin: 0 auto .32rem;
        @media screen and (max-width: module.$phone){
          width: 1.4rem;
          margin-bottom: .4rem;
        }
      }
    }
  }
  .lang{
    position: absolute;
    top: 1rem;
    right: calc(16rem);
    overflow: hidden;
    display: grid;
    grid-template-columns: auto 1fr;
    border-radius: 999rem;
    background: module.$white;
    @media screen and (max-width: module.$phone){
      right: module.side();
      top: 6rem;
    }
    &.pc{
      top: 2rem;
      right: calc(10rem);
    }
    > svg{
      fill: module.$normal;
      position: absolute;
      right: .64rem;
      top: 50%;
      transform: translateY(-50%);
      width: 1.2rem;
    }
    span{
      display: flex;
      align-items: center;
      justify-content: center;
      background: module.$white;
      padding: 0 .4rem;
      svg{
        width: 1.6rem;
        fill: module.$base;
      }
    }
    select{
      @include module.font();
      font-size: 1.04rem;
      line-height: 1.5;
      padding: .4rem 0;
      padding-right: 2rem;
      border: none;
      color: module.$normal;
      background: transparent;
      -webkit-appearance: none;
      appearance: none;
      cursor: pointer;
    }
  }
  .trg{
    position: fixed;
    top: 0;
    right: 0;
    width: 6.4rem;
    height: 6.4rem;
    cursor: pointer;
    overflow: hidden;
    z-index: 1000;
    @media screen and (max-width: module.$phone){
      width: $spSize;
      height: $spSize;
    }
    &:before,
    &:after{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: module.$base;
      z-index: -1;
    }
    &:after{
      width: 0;
      left: auto;
      right: 0;
      background: module.$black;
      transition: all 320ms module.$ease;
    }
    &:hover{
      &:after{
        width: 100%;
        left: 0;
        right: auto;
      }
    }
    &.active{
      &:after{
        width: 100%;
      }
      &:hover{
        &:after{
          background: module.$normal;
        }
      }
      i{
        width: 0;
        &:first-of-type,
        &:last-of-type{
          width: 40%;
          top: 50%;
        }
        &:first-of-type{
          transform: translate(-50%) rotate(45deg);
        }
        &:last-of-type{
          transform: translate(-50%) rotate(-45deg);
        }
      }
    }
    i{
      width: 33%;
      height: 1px;
      background: module.$white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%);
      transition: all 320ms module.$ease;
      &:first-of-type{
        top: calc(50% - .5rem);
      }
      &:last-of-type{
        top: calc(50% + .5rem);
      }
    }
  }
  .fix{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: module.$base;
    @media screen and (max-width: module.$tab){
      overflow: auto;
    }
  }
  nav{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9;
    @include module.texture();
    @include module.flex();
    align-items: center;
    justify-content: center;
    @media screen and (max-width: module.$phone){
      overflow: auto;
      display: grid;
      grid-template-columns: 1fr;
      > *{
        align-self: flex-start;
      }
    }
    .logo{
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
    }
    .pics{
      width: 50%;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      display: grid;
      @media screen and (max-width: module.$tab){
        width: 100%;
        height: 30%;
        grid-template-rows: 1fr;
      }
      @media screen and (max-width: module.$phone){
        height: 25%;
      }
      figure{
        position: relative;
        overflow: hidden;
        &:before{
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          right: 0;
          @include module.texture();
          z-index: 2;
          @media screen and (max-width: module.$phone){
            display: none;
          }
        }
        &:nth-of-type(odd){
          &:before{
            left: 0;
            right: auto;
          }
        }
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          position: relative;
        }
      }
      &.active{
        figure{
          &:before{
            animation: menuPicBefore 800ms 200ms module.$ease forwards;
          }
          img{
            animation: menuPic 1200ms module.$ease forwards;
          }
          @keyframes menuPicBefore {
            0%{
              width: 100%;
            }
            100%{
              width: 0;
            }
          }
          @keyframes menuPic {
            0%{
              transform: scale(1.1);
            }
            100%{
              transform: scale(1);
            }
          }
        }
      }
    }
    .menu{
      width: 50%;
      height: 100%;
      padding: 0 0 5.6rem;
      position: absolute;
      background: url(/images/common/menu_circle.webp) no-repeat left top / 80%;
      left: 0;
      top: 0;
      @include module.flex();
      align-items: center;
      justify-content: center;
      @media screen and (max-width: module.$tab){
        width: 100%;
        height: 70%;
        top: auto;
        bottom: 0;
      }
      @media screen and (max-width: module.$phone){
        display: grid;
        grid-template-rows: 2fr;
        order: 2;
        height: 75%;
        align-self: center;
      }
      ul{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2.4rem;
        grid-row-gap: 2.4rem;
        margin: 4rem 0 0;
        @media screen and (max-width: module.$tab){
          grid-column-gap: module.side();
          grid-row-gap: 2rem;
          margin: 0;
        }
        @media screen and (max-width: module.$phone){
          grid-template-columns: repeat(2, 1fr);
          padding: 3.2rem module.side() 1.6rem;
          text-align: center;
        }
        &.active{
          li{
            animation: showMenuList 600ms ease-in-out forwards;
            @for $i from 1 through 10{
              &:nth-child(#{$i}){
                animation-delay: $i * 40ms + 400ms;
              }
            }
            @keyframes showMenuList {
              0%{
                transform: translateY(2.4rem);
                opacity: 0;
              }
              100%{
                transform: translateY(0);
                opacity: 1;
              }
            }
          }
        }
        li{
          line-height: 1;
          opacity: 0;
          a{
            font-size: 3.72vmin;
            letter-spacing: .12rem;
            line-height: 1;
            color: module.$white;
            fill: module.$white;
            display: inline-block;
            position: relative;
            padding: .4rem;
            z-index: 1;
            @media screen and (max-width: module.$phone){
              font-size: 4.2vmin;
            }
            &:before{
              content: attr(data-eng);
              display: block;
              font-size: 1.6vmin;
              margin: 0 0 .8rem .24rem;
              letter-spacing: .08;
              white-space: nowrap;
              @media screen and (max-width: module.$phone){
                font-size: 3.2vmin;
                letter-spacing: .012vmin;
                margin: 0 0 .64rem;
                position: relative;
                top: 0;
                left: 0;
                width: 100%;
                background: none;
                transform: translateX(0);
              }
            }
            &:after{
              content: '';
              width: 0;
              height: 100%;
              background: module.$sub;
              position: absolute;
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              transition: width 320ms module.$ease;
              z-index: -1;
              @media screen and (max-width: module.$tab){
                display: none;
              }
            }
            &:hover{
              &:after{
                width: 100%;
                left: 0;
                right: auto;
              }
            }
            svg{
              width: 3.4vmin;
              height: 3.4vmin;
              display: inline-block;
              margin: 0 0 0 .8vmin;
              transform: translateY(.33vmin);
              @media screen and (max-width: module.$phone){
                width: 5vmin;
                height: 5vmin;
                transform: translateY(25%);
              }
            }
          }
        }
      }
    }
    .meta{
      width: 100%;
      position: absolute;
      right: 0;
      bottom: 0;
      color: module.$white;
      fill: module.$white;
      padding: 1.6rem module.side();
      display: grid;
      grid-template-columns: auto 1fr;
      grid-column-gap: 2rem;
      @media screen and (max-width: module.$phone){
        width: 100vw;
        position: relative;
        top: 0;
        left: 0;
        right: auto;
        bottom: auto;
        align-self: flex-end;
        grid-template-columns: 1fr;
        gap: 1rem;
      }
      > *{
        align-self: center;
        @media screen and (max-width: module.$phone){
          justify-self: center;
        }
      }
      dt{
        font-size: .92rem;
        line-height: 1.6;
        text-align: justify;
        @media screen and (max-width: module.$phone){
          font-size: .96rem;
          text-align: center;
        }
      }
      dd{
        font-size: 1.24rem;
        line-height: 1.4;
        @include module.flex();
        justify-content: flex-start;
        align-items: center;
        gap: .64rem;
        @media screen and (max-width: module.$phone){
          font-size: 1.32rem;
          display: block;
          line-height: 1.8;
        }
        svg{
          width: 2.32rem;
          height: 2.32rem;
        }
      }
    }
  }
}
</style>

<script>
import { computed, ref } from 'vue'

export default {

  setup() {
    const trg = ref(false)
    const langDefault = 'https://www.booking.com/hotel/jp/wakamatsu-honten.zh-cn.html?label=gen173nr-1FCAsodUIQd2FrYW1hdHN1LWhvbnRlbkgzWARodYgBAZgBFbgBBMgBBNgBAegBAfgBC6gCA9gCAw&sid=321e34d3bf57c40f79da6a0229c8840b&keep_landing=1&sb_price_type=total&type=total&'
    const lang = ref(langDefault)
    const wh = ref(window.innerWidth)
    const isWindow = computed(() => {
      if(wh.value < 1200){
        return true
      }else{
        return false
      }
    })
    const changeLocal = (e) => {
      window.open(lang.value, '_blank')
      lang.value = langDefault
    }
    window.addEventListener('resize', ()=>{
      wh.value = window.innerWidth
    })
    return {
      changeLocal,
      trg,
      lang,
      langDefault,
      isWindow,
    }
  },
}
</script>
